import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import ViniedoLogs from './ViniedoLogs';

function ViniedoLogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(
        () => state.ViniedoLogsPage,
        [state.ViniedoLogsPage]
    );

    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const params = useParams();

    useEffect(() => {
        const getViniedoLogsCuantity = async () => {
            try {
                setLoader(true);

                const ViniedoLogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 2,
                    objeto_id: parseInt(params.id),
                });

                if (ViniedoLogsCuantity)
                    setTablePages(ViniedoLogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getViniedoLogs = async () => {
            try {
                setLoader(true);

                const ViniedoLogs = await LogService.byObject({
                    token,
                    objeto: 2,
                    objeto_id: parseInt(params.id),
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (ViniedoLogs) {
                    setTableData(buildTableData(ViniedoLogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getViniedoLogsCuantity();
        getViniedoLogs();
    }, [tablePages, tablePage]);

    const buildTableData = (data = []) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            pageType: 'ViniedoLogsPage',
            data:
                data.length > 0
                    ? data?.map((log) => {
                          return {
                              fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                              hora: dayjs(log.fecha).format('HH:mm:ss'),
                              responsable: `${log.apellido}, ${log.nombre}`,
                              nivel: masters.UserTypes?.find(
                                  (m) => m.id === log.tipo
                              )?.nombre,
                              accion: masters.AccionTypes?.find(
                                  (at) => at.id === log.accion
                              ).nombre.replace(/_/g, ' '),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <ViniedoLogs tableData={tableData} />;
}

export default ViniedoLogsContainer;
